module.exports = __webpack_public_path__ + "static/foreign-trade-zone-1fbc6cbf6aa59f91fb4aeeca8fc49dab.jpg";